module.exports = __webpack_public_path__ + "static/media/lg04.ee065254.png";